import serviceLocator from 'live/services/service-locator'
import widgetsService from 'live/services/widgets'

// It's important to append displayUnit data.
export default function fixDisplayUnit(type: string) {
    let displayUnitStore: any | null = null
    serviceLocator.getService('plugin-assets:display-units').then(service => {
        displayUnitStore = service?.store
    })

    widgetsService.getUserConfigForDownload &&
        widgetsService.getUserConfigForDownload(type, cfg => {
            let displayUnitSetId = null
            if (typeof displayUnitStore?.getState === 'function') {
                displayUnitSetId = displayUnitStore.getState()?.selectedUnitSet?.id
            }

            return { assets: cfg.assets, download: true, displayUnitSetId }
        })
}
